import { Maybe } from './classes/graphql'
import { MaybeType } from './types'

type ObjectOrArray<T> = T | T[]

export const getValue = <T>(value: ObjectOrArray<T>) => {
  return value && value !== null ? value : undefined
}

export const getAsKey = <T>(keyName: keyof T) => {
  return keyName
}

export const filterOutNullValues = <T>(items: Maybe<T>[]): T[] =>
  items?.filter((item): item is T => item !== null)

export const isNotNullOrUndefined = <T>(val: MaybeType<T>): val is T => {
  return val != null
}
